import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputError from '../../../errors/InputError';
import TextInput from '../text-input/TextInput';
import './ToggleInput.css';

export default class ToggleInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedId: (this.props.selectedId) ? this.props.selectedId : null
    }
    this.arrayOfVisibleInputs = []
    this.valuesObj = {}
  }

  // Default radio select
  componentWillReceiveProps(newProps) {
    if ('selectedId' in newProps && newProps.selectedId !== undefined && newProps.selectedId !== this.state.selectedId) {
      this.setState({ selectedId: newProps.selectedId });
    }
  }

  // radio change
  onChange = (event, radioId) => {
    this.setState({ selectedId: radioId });
    if (this.props.onChange) {
      this.props.onChange(event, radioId);
    }
  }

  // this is handled when the input-list form submits
  // on form submit, return an object based on the visible inputs
  // if it's empty return an error to the form
  getValue = () => {
    let inputsObj = {}
    for (let key in this.valuesObj) {
      if (this.ArrayOfVisibleInputs.find(val => val === key)) {
        inputsObj[key] = this.valuesObj[key]
      }

      // set nan vals to 0
      if (isNaN(this.valuesObj[key]))
        inputsObj[key] = 0;
    }

    let allAreZero = Object.values(inputsObj).every(val => val === 0)
    let isEmptyObject = (this.props.required && Object.keys(inputsObj).length === 0 && inputsObj.constructor === Object)

    if (this.props.required && (isEmptyObject || allAreZero)) {
      throw new InputError(this.props.label + " is Required", inputsObj);
    }

    return inputsObj
  }

  // each time the text changes, update valuesObj with event value (number)
  handleTextChange = (event) => {
    this.ArrayOfVisibleInputs.forEach((input) => {
      if (input === event.target.id) {
        this.valuesObj[input] = event.target.valueAsNumber;
      }
    })

    this.setState(this.valuesObj);
  }

  render() {

    // Required and Error Messages
    const requiredFieldIndicator = (this.props.required)
      ? <abbr title="This field is required">*</abbr>
      : null;

    let errorMessage = (this.props.errorMessage)
      ? <span className="error-message">
        {this.props.errorMessage}
      </span>
      : null

    // Radio button elements
    const radioButtons = this.props.radioProps.map((radioProp, index) => {
      let radio = (
        <input
          type="radio"
          id={radioProp.id}
          value={radioProp.value}
          checked={(radioProp.checked) ? radioProp.checked : this.state.selectedId === radioProp.id}
          onChange={(event) => this.onChange(event, radioProp.id)}
        />
      );

      let label = (<label htmlFor={radioProp.id}>{radioProp.label}</label>);

      return (
        <div key={radioProp.id} className="radio-button">{radio}{label}</div>
      );
    })

    // Input text elements
    const inputs = this.props.selectInputList.map((input) => {

      if (this.state.selectedId === input.id) {
        if (input.multiInputs) {
          this.ArrayOfVisibleInputs = []
          return input.multiInputs.map((input2) => {
            this.ArrayOfVisibleInputs.push(input2.id)
            return (
              <TextInput
                key={input2.id}
                id={input2.id}
                className="field__large"
                type="number"
                numberMin={input2.numberMin}
                numberStep={input2.numberStep}
                placeholderText={input2.placeholderText}
                onChange={(event) => this.handleTextChange(event)} />)
          })
        } else {
          this.ArrayOfVisibleInputs = [input.id]
          return (
            <TextInput
              key={input.id}
              id={input.id}
              className="field__large"
              type="number"
              numberMin={input.numberMin}
              numberStep={input.numberStep}
              placeholderText={input.placeholderText}
              onChange={(event) => this.handleTextChange(event)}
            />)
        }
      }
    })


    return (
      <div className="toggle-input">
        <div className="fields-inline">
          <label className="toggle-input-label">{requiredFieldIndicator}{this.props.label}</label>

          {inputs}

          <div>
            <fieldset id={this.props.id} disabled={this.props.disabled} className="field__group radio-input-list">
              <legend>{this.props.legend}</legend>
              {radioButtons}
            </fieldset>
          </div>

          {errorMessage}
        </div>
      </div>
    )
  }
}

ToggleInput.propTypes = {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  radioProps: PropTypes.arrayOf(PropTypes.shape({
    checked: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  required: PropTypes.bool,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectInputList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string,
    numberMin: PropTypes.string,
    numberStep: PropTypes.string,
    multiInputs: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      placeholderText: PropTypes.string,
      value: PropTypes.string,
      numberMin: PropTypes.string,
      numberStep: PropTypes.string,
    }))
  })).isRequired
}



// WEBPACK FOOTER //
// ./src/shared/components/presentation/toggle-input/ToggleInput.js